<mat-card [matBadge]="badgeText" [matBadgeColor]="badgeColor" class="home-card stretch-badge" (click)="handleClick()" [ngClass]="{'faint':disabled}"
  [matTooltip]="disabled ? (disabledMessage || ('homeCard.unsignedFormsTooltip' | translate)) : ''"
  matTooltipPosition="above">

  @if (isExternalRoute) {
    <span class="external-link-badge" [title]="'homeCard.externalLink' | translate">
      <mat-icon class="external-link-icon-material">open_in_new</mat-icon>
    </span>
  }

  <div class="container grow center pt-1">
    <div class="flex center">
      <mat-icon class="home-icon-material">{{ iconName }}</mat-icon>
    </div>
  </div>
  <div class="flex center header" [ngClass]="titleFontClass">
    {{ translatedTitle }}
  </div>

</mat-card>
